/*
 *  File: environment.prod.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { appconfig } from '../app/config/app-config';
import { appextconfig } from '../app/config/app-extconfig-prod';
/**
 *
 * @author dlolugu1271
 * @description This an environment file for PROD which contains production specific 
 * config or external configuration values
 */
export const environment = {
  production: true,
  appconfig: appconfig,
  appextconfig: appextconfig
};



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/environments/environment.ts